import { Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})

export class DataLayerService {

  dataLayerCallback(callback: boolean, successMsg:string,emailID?:string,phoneNumber?:string) {
        window['dataLayer'] = window['dataLayer'] || [];
        window['dataLayer'].push({
          'event':successMsg,
           'email_id': emailID || '',
          'phone_number': phoneNumber || ''
        });
      }
}
